/* ============================================================
   MARECHAL — motion.js v2
   Motor de animações. Aditivo e defensivo.
   ============================================================ */
(function () {
  'use strict';

  var docEl  = document.documentElement;
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  docEl.classList.add('js-motion');

  /* ---------- Gate do preloader ---------- */
  function isPreloading() {
    return docEl.classList.contains('apm-locked');
  }

  function whenRevealed(cb) {
    if (!isPreloading()) { cb(); return; }
    var settled = false;
    var observer;
    var done = function () {
      if (settled) return;
      settled = true;
      if (observer) observer.disconnect();
      cb();
    };
    observer = new MutationObserver(function () {
      if (!isPreloading()) done();
    });
    observer.observe(docEl, { attributes: true, attributeFilter: ['class'] });
    setTimeout(done, 8000);
  }

  /* ---------- Contadores ---------- */
  function easeOutQuart(t) { return 1 - Math.pow(1 - t, 4); }
  function formatCount(prefix, n) {
    return prefix + Math.floor(n).toLocaleString('pt-BR');
  }
  function animateCounter(el) {
    var start    = parseInt(el.dataset.start, 10) || 0;
    var end      = parseInt(el.dataset.end, 10) || 0;
    var duration = parseInt(el.dataset.duration, 10) || 2500;
    var delay    = parseInt(el.dataset.delay, 10) || 0;
    var prefix   = el.dataset.prefix || '';
    if (REDUCED) { el.textContent = formatCount(prefix, end); return; }
    setTimeout(function () {
      var startTime = null;
      function step(ts) {
        if (startTime === null) startTime = ts;
        var progress = Math.min((ts - startTime) / duration, 1);
        el.textContent = formatCount(prefix, start + (end - start) * easeOutQuart(progress));
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          el.textContent = formatCount(prefix, end);
          el.classList.add('m-done');
        }
      }
      requestAnimationFrame(step);
    }, delay);
  }
  function initCounters() {
    var counters = document.querySelectorAll('.hero-mch__counter:not([data-counted]), [data-counter]:not([data-counted])');
    Array.prototype.forEach.call(counters, function (el) {
      el.setAttribute('data-counted', 'true');
      whenRevealed(function () { animateCounter(el); });
    });
  }

  /* ---------- Coreografia do Hero ---------- */
  function initHero() {
    var hero = document.querySelector('.hero-mch');
    if (!hero) { docEl.classList.add('m-revealed'); return; }
    var content = hero.querySelector('.hero-mch__content');
    if (content) {
      Array.prototype.forEach.call(content.children, function (item, i) {
        if (item.nodeType !== 1) return;
        item.classList.add('m-hero-item');
        item.style.setProperty('--m-i', i);
      });
    }
    var art = hero.querySelector('.hero-mch__art');
    if (art) art.classList.add('m-hero-art');
    whenRevealed(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          docEl.classList.add('m-revealed');
        });
      });
    });
    if (!REDUCED && window.matchMedia('(min-width: 990px)').matches) {
      var img = hero.querySelector('.hero-mch__art img');
      if (img) {
        img.style.transform = 'translateY(0) scale(1.06)';
        var ticking = false;
        window.addEventListener('scroll', function () {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(function () {
            var rect = hero.getBoundingClientRect();
            if (rect.bottom > 0) {
              var offset = Math.min(Math.max(-rect.top, 0) * 0.12, 40);
              img.style.transform = 'translateY(' + offset + 'px) scale(1.06)';
            }
            ticking = false;
          });
        }, { passive: true });
      }
    }
  }

  /* ---------- Revelação ao rolar ---------- */
  var REVEAL_GROUPS = [
    '.benefits',
    '.cat-grid__list',
    '.promo-cards',
    '.services__grid',
    '.guides__grid'
  ];
  var REVEAL_SINGLES = [
    '.section-head',
    '.product-slider',
    '.vehicle-finder__intro',
    '.vehicle-finder__form',
    '.code-search__box',
    '.specialist__panel',
    '.showcase__grid',
    '.img-banner__inner',
    '.seo-text'
  ];

  function revealEl(el) {
    if (!el.classList.contains('m-reveal')) return;
    el.classList.add('m-in');
    setTimeout(function () {
      el.classList.remove('m-reveal', 'm-in');
      el.style.removeProperty('--m-i');
    }, 1200);
  }

  function initReveals() {
    if (REDUCED) return;

    var targets = [];

    REVEAL_GROUPS.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (group) {
        Array.prototype.forEach.call(group.children, function (child, i) {
          if (child.nodeType !== 1) return;
          child.classList.add('m-reveal');
          child.style.setProperty('--m-i', Math.min(i, 8));
          targets.push(child);
        });
      });
    });

    REVEAL_SINGLES.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
        if (el.closest('.hero-mch')) return;
        el.classList.add('m-reveal');
        targets.push(el);
      });
    });

    if (!targets.length) return;

    /* --- Abordagem 1: IntersectionObserver (threshold=0, sem rootMargin) --- */
    if ('IntersectionObserver' in window) {
      var remaining = targets.slice();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            revealEl(entry.target);
            io.unobserve(entry.target);
            remaining = remaining.filter(function (t) { return t !== entry.target; });
          }
        });
      }, { threshold: 0, rootMargin: '0px' });

      remaining.forEach(function (t) { io.observe(t); });

      /* --- Fallback: scroll manual para garantir que nada fique preso --- */
      var scrollFallback = function () {
        var vph = window.innerHeight;
        remaining = remaining.filter(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < vph && r.bottom > 0) {
            revealEl(el);
            io.unobserve(el);
            return false;
          }
          return true;
        });
        if (!remaining.length) {
          window.removeEventListener('scroll', scrollFallback);
        }
      };
      window.addEventListener('scroll', scrollFallback, { passive: true });

      /* --- Fallback absoluto: após 4s revela tudo que ainda estiver invisível --- */
      setTimeout(function () {
        remaining.forEach(function (el) {
          revealEl(el);
          io.unobserve(el);
        });
        remaining = [];
        window.removeEventListener('scroll', scrollFallback);
      }, 4000);

    } else {
      /* Sem IO: revelar tudo imediatamente */
      targets.forEach(function (el) { revealEl(el); });
    }
  }

  /* ---------- Marquee de marcas ---------- */
  function initBrandsMarquee() {
    if (REDUCED) return;
    var list = document.querySelector('.brands__list');
    if (!list || list.children.length < 6) return;
    var viewport = document.createElement('div');
    viewport.className = 'm-marquee-viewport';
    list.parentNode.insertBefore(viewport, list);
    viewport.appendChild(list);
    var originals = Array.prototype.slice.call(list.children);
    originals.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      var links = clone.querySelectorAll('a');
      Array.prototype.forEach.call(links, function (a) { a.setAttribute('tabindex', '-1'); });
      list.appendChild(clone);
    });
    list.classList.add('m-marquee');
    requestAnimationFrame(function () {
      var half = list.scrollWidth / 2;
      var dur  = Math.max(half / 40, 18);
      list.style.setProperty('--m-marquee-dur', dur.toFixed(1) + 's');
    });
  }

  /* ---------- Boot ---------- */
  function init() {
    try { initHero(); } catch (e) { docEl.classList.add('m-revealed'); }
    try { initCounters(); } catch (e) {}
    try { initReveals(); } catch (e) {}
    try { initBrandsMarquee(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();